@if (user$ | async; as user) {
    <div>
        @if ((isMobile$ | async) === false) {
            <button
                mat-button
                class="toolbar-button"
                data-testid="user-dropdown-trigger"
                [matMenuTriggerFor]="menu"
            >
                <mat-icon class="desktop-account-icon">{{ accountIconOrDefault }}</mat-icon>
                {{ user.displayName }}
                <mat-icon class="chevron-icon">expand_more</mat-icon>
            </button>
        }
        @if (isMobile$ | async) {
            <button
                mat-icon-button
                class="mobile-account-icon-button"
                data-testid="user-dropdown-trigger"
                [matMenuTriggerFor]="menu"
            >
                <mat-icon>{{ accountIconOrDefault }}</mat-icon>
            </button>
        }
        <mat-menu #menu="matMenu">
            @if (isMobile$ | async) {
                <div
                    mat-menu-item
                    disabled
                >
                    <mat-icon>account_circle</mat-icon>
                    {{ user.displayName }}
                </div>
            }
            <ng-content></ng-content>
            <button
                mat-menu-item
                data-testid="logout-menu-item"
                (click)="logout($event)"
            >
                <mat-icon>logout</mat-icon>
                Logout
            </button>
        </mat-menu>
    </div>
}
